import React, { useContext, useState } from "react";
import { useParams } from "react-router-dom";

import {
  FullviewerSet,
  ModeSet,
  Area1Set,
  Area2Set,
  ShowratioSet,
  ModalcolorSet,
  Static2Map1Set,
  Static2Map2Set,
  Zoomlevel1Set,
  Zoomhanrei1Set,
  Zoomhanrei2Set,
  Year1Set,
  Year2Set,
  RendouSet,
  SyukurenSet,
  SyosaiSet,
  StartmodalSet,
} from "./../../App";

import data_meta1 from "./../metadatas/meta_data_20260211_g";
import meta_mieruka from "./../../mieruka/meta_mieruka_20260121";
let data_meta = data_meta1.concat(meta_mieruka);

import Hanrei from "./hanrei";
import Hanreikokudo from "./hanreikokudo";
import { Hanreikakudai } from "./hanreikakudai";

export const HanreiGeograph = ({ meta, meta2, children }) => {
  const { fullviewerset, setFullviewerSet } = useContext(FullviewerSet);
  const { modeset, setModeSet } = useContext(ModeSet);
  const { startmodalset, setStartmodalSet } = useContext(StartmodalSet);

  const [showcityset, setShowcityset] = useState(false);
  const [filecheckset, setFilecheckset] = useState(0);

  const { static2map1set, setStatic2Map1Set } = useContext(Static2Map1Set);
  const { static2map2set, setStatic2Map2Set } = useContext(Static2Map2Set);
  const { area1set, setArea1Set } = useContext(Area1Set);
  const { area2set, setArea2Set } = useContext(Area2Set);
  const { year1set, setYear1Set } = useContext(Year1Set);
  const { year2set, setYear2Set } = useContext(Year2Set);
  const { zoomlevel1set, setZoomlevel1Set } = useContext(Zoomlevel1Set);
  const { zoomhanrei1set, setZoomhanrei1Set } = useContext(Zoomhanrei1Set);
  const { rendouset, setRendouSet } = useContext(RendouSet);
  const { syukurenset, setSyukurenSet } = useContext(SyukurenSet);
  const { syosaiset, setSyosaiSet } = useContext(SyosaiSet);
  const { modalcolorset, setModalcolorSet } = useContext(ModalcolorSet);
  const { showratioset, setShowratioSet } = useContext(ShowratioSet);

  const params = useParams();

  return (
    <>
      <div className="absolute z-30 w-full mt-20 md:mt-24 pointer-events-none">
        <div className="flex my-4">
          {params.mode == 8 && (
            <>
              <div className="w-1/4 lg:w-1/4 max-h-[10vh] z-30">
                <div className="text-sm md:text-base text-white pointer-events-auto rounded-lg bg-gradient-to-r from-black/50 via-black/70 to-black/90">
                  {/* ===== 凡例 ===== */}
                  <details open className="group">
                    <summary
                      className="
                        list-none cursor-pointer select-none
                        flex items-center justify-between
                        h-10 px-5
                        font-extrabold
                        rounded-lg
                        bg-gradient-to-r from-black/40 via-black/60 to-black/80
                        hover:from-black/50 hover:via-black/70 hover:to-black/90
                        focus:outline-none focus:ring-2 focus:ring-black/70
                      "
                    >
                      <span>凡例</span>
                      <span className="text-white/80 transition-transform group-open:rotate-180">
                        ▾
                      </span>
                    </summary>

                    {!zoomhanrei1set && params.mode != 5 && (
                      <div className="overflow-auto max-h-[45vh] bg-gradient-to-r from-white/70 via-white/80 to-white/90">
                        <Hanrei metadata={meta2} csv={"dataのURL"} />
                      </div>
                    )}

                    {!zoomhanrei1set && params.mode == 5 && (
                      <div className="overflow-auto max-h-[25vh] bg-gradient-to-r from-white/70 via-white/80 to-white/90">
                        <Hanreikokudo metadata={meta} csv={"dataのURL"} />
                      </div>
                    )}

                    {zoomhanrei1set && (
                      <div className="overflow-auto max-h-[50vh]">
                        <Hanreikakudai metadata={meta2} csv={"dataのURL"} />
                      </div>
                    )}

                    {/* ===== TRY ===== */}
                    {zoomlevel1set == 1 && params.mode == 1 && (
                      <details open className="group mt-2">
                        <summary
                          className="
                            list-none cursor-pointer select-none
                            flex items-center justify-between
                            h-10 px-5
                            font-extrabold text-xs md:text-sm
                            rounded-lg
                            bg-gradient-to-r from-green-900/70 via-green-900/80 to-green-950/90
                            hover:from-green-900/80 hover:via-green-900/90 hover:to-green-950
                            focus:outline-none focus:ring-2 focus:ring-green-400/60
                          "
                        >
                          <span>TRY</span>
                          <span className="text-white/80 transition-transform group-open:rotate-180">
                            ▾
                          </span>
                        </summary>

                        <div className="overflow-auto max-h-[30vh] text-white bg-gradient-to-r from-green-800 via-green-800 to-green-900 text-xs md:text-sm px-3 py-3 font-serif text-left">
                          {meta.try}
                        </div>
                      </details>
                    )}

                    {/* ===== 解説 ===== */}
                    {zoomlevel1set == 1 &&
                      (params.mode == 4 ||
                        params.mode == 6 ||
                        params.mode == 7) && (
                        <details open className="group mt-2">
                          <summary
                            className="
                              list-none cursor-pointer select-none
                              flex items-center justify-between
                              h-10 px-5
                              font-extrabold text-xs md:text-sm
                              rounded-lg
                              bg-gradient-to-r from-green-900/70 via-green-900/80 to-green-950/90
                              hover:from-green-900/80 hover:via-green-900/90 hover:to-green-950
                              focus:outline-none focus:ring-2 focus:ring-green-400/60
                            "
                          >
                            <span>解説</span>
                            <span className="text-white/80 transition-transform group-open:rotate-180">
                              ▾
                            </span>
                          </summary>

                          <div className="overflow-auto max-h-[20vh] text-white bg-gradient-to-r from-green-800 via-green-800 to-green-900 font-medium text-xs md:text-sm px-3 py-3 font-serif">
                            {meta.kaisetsu}
                          </div>
                        </details>
                      )}
                  </details>
                </div>
              </div>
              <div className="w-1/2"></div>
            </>
          )}

          <div className="w-1/4 lg:w-1/4 max-h-[10vh] z-30">
            <div className="text-sm md:text-base text-white pointer-events-auto rounded-lg bg-gradient-to-r from-black/50 via-black/70 to-black/90">
              {/* ===== 凡例 ===== */}
              <details open className="group">
                <summary
                  className="
                    list-none cursor-pointer select-none
                    flex items-center justify-between
                    h-10 px-5
                    font-extrabold
                    rounded-lg
                    bg-gradient-to-r from-black/40 via-black/60 to-black/80
                    hover:from-black/50 hover:via-black/70 hover:to-black/90
                    focus:outline-none focus:ring-2 focus:ring-black/70
                  "
                >
                  <span>凡例</span>
                  <span className="text-white/80 transition-transform group-open:rotate-180">
                    ▾
                  </span>
                </summary>

                {!zoomhanrei1set && params.mode != 5 && (
                  <div className="overflow-auto max-h-[45vh] bg-gradient-to-r from-white/70 via-white/80 to-white/90">
                    <Hanrei metadata={meta} csv={"dataのURL"} />
                  </div>
                )}

                {!zoomhanrei1set && params.mode == 5 && (
                  <div className="overflow-auto max-h-[25vh] bg-gradient-to-r from-white/70 via-white/80 to-white/90">
                    <Hanreikokudo metadata={meta} csv={"dataのURL"} />
                  </div>
                )}

                {zoomhanrei1set && (
                  <div className="overflow-auto max-h-[50vh]">
                    <Hanreikakudai metadata={meta} csv={"dataのURL"} />
                  </div>
                )}

                {/* ===== TRY ===== */}
                {zoomlevel1set == 1 && params.mode == 1 && (
                  <details open className="group mt-2">
                    <summary
                      className="
                        list-none cursor-pointer select-none
                        flex items-center justify-between
                        h-10 px-5
                        font-extrabold text-xs md:text-sm
                        rounded-lg
                        bg-gradient-to-r from-green-900/70 via-green-900/80 to-green-950/90
                        hover:from-green-900/80 hover:via-green-900/90 hover:to-green-950
                        focus:outline-none focus:ring-2 focus:ring-green-400/60
                      "
                    >
                      <span>TRY</span>
                      <span className="text-white/80 transition-transform group-open:rotate-180">
                        ▾
                      </span>
                    </summary>

                    <div className="overflow-auto max-h-[30vh] text-white bg-gradient-to-r from-green-800 via-green-800 to-green-900 text-xs md:text-sm px-3 py-3 font-serif text-left">
                      {meta.try}
                    </div>
                  </details>
                )}

                {/* ===== 解説 ===== */}
                {zoomlevel1set == 1 &&
                  (params.mode == 4 ||
                    params.mode == 6 ||
                    params.mode == 7) && (
                    <details open className="group mt-2">
                      <summary
                        className="
                          list-none cursor-pointer select-none
                          flex items-center justify-between
                          h-10 px-5
                          font-extrabold text-xs md:text-sm
                          rounded-lg
                          bg-gradient-to-r from-green-900/70 via-green-900/80 to-green-950/90
                          hover:from-green-900/80 hover:via-green-900/90 hover:to-green-950
                          focus:outline-none focus:ring-2 focus:ring-green-400/60
                        "
                      >
                        <span>解説</span>
                        <span className="text-white/80 transition-transform group-open:rotate-180">
                          ▾
                        </span>
                      </summary>

                      <div className="overflow-auto max-h-[20vh] text-white bg-gradient-to-r from-green-800 via-green-800 to-green-900 font-medium text-xs md:text-sm px-3 py-3 font-serif">
                        {meta.kaisetsu}
                      </div>
                    </details>
                  )}
              </details>
            </div>
          </div>

          {children}
        </div>
      </div>
    </>
  );
};
